<div app-modal-content class="flex flex-col !p-0">
  <app-modal-header>
    <div class="flex">
      <div
        class="h-12 w-12 flex-shrink-0 self-start rounded-tl-lg p-2 text-theme-600 [box-shadow:0px_2px_4px_0px_rgba(0,_0,_0,_0.15)]"
      >
        <svg-icon src="assets/icons/icon-duplicate-2.svg"></svg-icon>
      </div>
      <hr app-modal-divider />
      <div class="flex items-center gap-2">
        <p class="text-md font-medium not-italic leading-[normal] md:text-lg" translate>
          trilhas.estudio.duplicar-curso
        </p>
      </div>
    </div>
  </app-modal-header>
  <form [formGroup]="form" class="m-form" (submit)="onSave()">
    <div app-modal-content class="flex-1 overflow-auto p-4">
      <app-form-field class="mb-5 w-full">
        <label translate app-label class="!text-md text-theme-900">trilhas.estudio.colecao-destino</label>
        <ng-select
          app-select
          formControlName="collection_id"
          [placeholder]="'trilhas.estudio.placeholder-selecione-colecao' | translate"
          [items]="collections$ | async"
          bindLabel="name"
          bindValue="id"
          groupBy="category_name"
          [ngClass]="{
            'ng-invalid ng-touched': form.controls['collection_id'].invalid && form.controls['collection_id'].touched
          }"
        >
        </ng-select>
      </app-form-field>
      <div class="flex justify-center" *ngIf="!!data.selectedCourse">
        <app-card
          class="hover:ring-b-theme-500 duration-50 w-[13rem] cursor-pointer !rounded-2xl ring-1 ring-theme-900 hover:shadow-lg"
        >
          <div app-card-content class="mb-3">
            <img
              [src]="data.selectedCourse.thumbnail"
              onerror="this.src='../../../../../assets/images/default.png'"
              alt="image course"
              class="h-[130px] rounded-t-xl"
            />
          </div>
          <hr app-divider />
          <div app-card-footer class="relative flex flex-col items-start gap-1 rounded-b-xl pt-2">
            <p class="text-xs font-semibold">{{ data.selectedCourse.titulo }}</p>
          </div>
        </app-card>
      </div>
    </div>
    <div app-modal-footer class="flex-shrink-0 justify-center gap-4 p-8">
      <button
        app-outline-button
        class="!h-10 w-48 border-base-status-danger font-medium uppercase text-base-status-danger hover:[&:not([disabled])]:bg-base-status-danger hover:[&:not([disabled])]:text-theme-contrast"
        type="button"
        (click)="onClose()"
        translate
      >
        trilhas.estudio.curso.cancelar
      </button>
      <button
        app-outline-button
        class="w-48 border-theme-500 font-medium uppercase text-theme-500 hover:[&:not([disabled])]:bg-theme-500 hover:[&:not([disabled])]:text-theme-contrast"
        type="submit"
        translate
      >
        trilhas.estudio.curso.salvar
      </button>
    </div>
  </form>
</div>
